import React, { Component } from 'react'
import PropTypes from 'prop-types'

import isEqual from 'lodash.isequal'

import {
  Input, Row, Col, Button, Loader,
} from 'shpmtcd'
import { validateEmail, validateName, validatePhoneNumber } from '../../utils/validations'
import ActionFeedback from './ActionFeedback'
import FeedbackAction from '../../shared/actionFeedback/container'
import { findSelectedCountryObj } from '../../utils/countires'
import { initPageView } from '../../Analytics/common'

const prefixText = (phoneCode) => (
  <span className='prefixText'>
    {`+${phoneCode}`}
  </span>
)

const initValidationState = {
  emailValidationState: {
    isValid: true,
    validationMessages: '',
  },
  phoneNumberValidationState: {
    isValid: true,
    validationMessages: '',
  },
  firstNameValidationState: {
    isValid: true,
    validationMessages: '',
  },
  lastNameValidationState: {
    isValid: true,
    validationMessages: '',
  },
}

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      enableCancel: false,
      emailValue: props.profileData.email,
      firstName: props.profileData.first_name,
      lastName: props.profileData.last_name,
      phoneNumber: props.profileData.phone,
      showFeedback: false,
      ...initValidationState,
    }
  }

  componentDidMount() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.fetchProfileData()
    initPageView()
  }

  componentDidUpdate(prevProps) {
    const { profileData } = this.props
    if (!isEqual(prevProps.profileData, profileData)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        emailValue: profileData.email,
        firstName: profileData.first_name,
        lastName: profileData.last_name,
        phoneNumber: profileData.phone,
        enableCancel: false,
      })
    }
  }

  handleEmailChange = (e) => {
    const { verifyEmail, profileData } = this.props
    const sameAsBefore = profileData.email === e.target.value
    const validationState = validateEmail(e.target.value)
    this.setState({
      emailValidationState: validationState,
      emailValue: e.target.value,
    })
    if (validationState.isValid && (!sameAsBefore)) {
      verifyEmail(e.target.value)
    }
    if (!sameAsBefore) { this.handlChangeInInputs() }
  }

  handleNumberChange = (e, countryCode) => {
    const phoneNumber = e.target.value
    const { countriesOption } = this.props
    const { phoneNumberValidationState } = this.state

    const countryObj = findSelectedCountryObj(countriesOption, `+${countryCode}`, 'phone_code')
    const validationState = countryObj
      ? validatePhoneNumber(phoneNumber, countryObj.phone_length)
      : phoneNumberValidationState

    this.setState({
      phoneNumber,
      phoneNumberValidationState: validationState,
    })
    this.handlChangeInInputs()
  }

  handleInputs = (e, stateName) => {
    const placeholderName = stateName === 'firstName' ? 'first' : 'last'
    const validationState = validateName(e.target.value, placeholderName)
    this.setState({
      [stateName]: e.target.value,
      [`${stateName}ValidationState`]: validationState,
    })
    this.handlChangeInInputs()
  }

  handlChangeInInputs = () => {
    this.setState({
      enableCancel: true,
    })
  }

  handleCancel = () => {
    const { profileData } = this.props
    this.setState({
      emailValue: profileData.email,
      firstName: profileData.first_name,
      lastName: profileData.last_name,
      phoneNumber: profileData.phone,
      enableCancel: false,
      showFeedback: false,
      ...initValidationState,
    })
  }

  handleOnSave = () => {
    const { profileData } = this.props
    const { emailValue } = this.state
    const isEmailChanged = emailValue !== profileData.email

    if (isEmailChanged) {
      this.setState({
        showFeedback: true,
      })
    } else {
      this.handleOnSubmit()
    }
  }

  handleOnSubmit = () => {
    const {
      emailValue, phoneNumber, firstName, lastName,
    } = this.state
    const { onClickSave, profileData } = this.props
    this.setState({
      showFeedback: false,
    })
    const params = {
      email: emailValue,
      phone: phoneNumber,
      first_name: firstName,
      last_name: lastName,
      country_code: profileData.country_code,
    }
    onClickSave(params)
  }

  enableSaveButton = () => {
    const {
      firstNameValidationState: fV,
      lastNameValidationState: lV,
      phoneNumberValidationState: phV,
      emailValidationState: emV,
      enableCancel,
      emailValue: emS,
      phoneNumber: phS,
      firstName: fS,
      lastName: lS,
    } = this.state

    const { customerEmailExists, profileData } = this.props
    const {
      email: emP,
      phone: phP,
      first_name: fP,
      last_name: lP,
    } = profileData

    const valueChanged = (emS !== emP) || (phS !== phP) || (fS !== fP) || (lS !== lP)
    const isButtonEnabled = enableCancel && emV.isValid && phV.isValid
    && lV.isValid && fV.isValid
    && !customerEmailExists

    return isButtonEnabled && valueChanged
  }

  render() {
    const {
      profileData,
      disableInputFeild,
      apiActionFeedback,
      emailVerificationInProgess,
    } = this.props
    const {
      emailValue,
      phoneNumber,
      firstName,
      lastName,
      emailValidationState,
      showFeedback,
      phoneNumberValidationState,
      firstNameValidationState,
      lastNameValidationState,
      enableCancel,
    } = this.state

    const isEnabled = this.enableSaveButton()

    return (
      <section className='myprofile-section-wrapper'>
        <h3 className='title'> My Profile </h3>
        <Row
          gutter={20}
          style={{ margin: 0 }}
          className='myprofile-wrapper'
        >
          <Row type='flex' gutter={20} className='profile-name-wrapper'>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input
                value={firstName}
                label='First Name'
                type='text'
                onChange={(e) => this.handleInputs(e, 'firstName')}
                error={firstNameValidationState.validationMessages.toString()}
                disabled={disableInputFeild}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input
                value={lastName}
                label='Last Name'
                type='text'
                disabled={disableInputFeild}
                error={lastNameValidationState.validationMessages.toString()}
                onChange={(e) => this.handleInputs(e, 'lastName')}
              />
            </Col>
          </Row>

          <Row gutter={20} className='profile-contact-wrapper'>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input
                prefix={prefixText(profileData.country_code)}
                value={phoneNumber}
                label='Phone number'
                type='number'
                disabled={disableInputFeild}
                error={phoneNumberValidationState.validationMessages.toString()}
                onChange={(e) => this.handleNumberChange(e, profileData.country_code)}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} />
          </Row>

          <Row gutter={20} className='profile-email-wrapper'>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Input
                value={emailValue}
                label='Email'
                type='email'
                disabled={disableInputFeild}
                error={emailValidationState.validationMessages.toString()}
                onChange={this.handleEmailChange}
              />
            </Col>
            {
              emailVerificationInProgess
                ? (
                  <div className='email-check'>
                    <Loader processText='Checking E-mail' />
                  </div>
                )
                : null
            }
          </Row>

        </Row>

        {apiActionFeedback && <FeedbackAction />}

        <div className='profile-action-wrapper'>
          <Button
            disabled={!enableCancel}
            onClick={this.handleCancel}
          >Cancel
          </Button>
          <Button
            type='Primary'
            disabled={!isEnabled}
            onClick={this.handleOnSave}
          >Save
          </Button>
        </div>
        <ActionFeedback
          showFeedback={showFeedback}
          onCancel={this.handleCancel}
          onSubmit={this.handleOnSubmit}
        />

      </section>
    )
  }
}

Profile.propTypes = {
  customerEmailExists: PropTypes.bool.isRequired,
  emailVerificationInProgess: PropTypes.bool.isRequired,
  countriesOption: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    phone_code: PropTypes.string,
    phone_length: PropTypes.shape([]),
  })).isRequired,
  disableInputFeild: PropTypes.bool.isRequired,
  profileData: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
    country_code: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  apiActionFeedback: PropTypes.bool.isRequired,
  onClickSave: PropTypes.func.isRequired,
  fetchProfileData: PropTypes.func.isRequired,
  verifyEmail: PropTypes.func.isRequired,
}

export default Profile
